// extracted by mini-css-extract-plugin
export default {"clock":"Stopwatch_clock__jgPK2","onOffButton":"Stopwatch_onOffButton__GbQg2","active":"Stopwatch_active__-zzCj"};